import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import SurveyCreatorPage from './SurveyCreatorPage';
import {
  getSurvey,
  loadSchemaTypes,
  saveSurvey,
  setSelectedSchemaType,
} from '../../redux/modules/surveyCreator/surveyCreatorCreator';
import { bindActionCreators, Dispatch } from 'redux';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    schemaTypes: state.surveyCreator.schemaTypelist,
    selectedSurvey: state.surveyCreator.selectedSchema,
    isLoading: state.surveyCreator.isLoading,
    selectedType: state.surveyCreator.selectedType,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      saveSurvey,
      loadSchemaTypes,
      getSurvey,
      setSelectedSchemaType,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyCreatorPage);
